<template>
  <div v-title data-title="我的" class="my">
    <div class=" my">
      <div id="coupon" class="">
        <div class="mine-info bg-white" style="height: 50px;position: fixed;width: 100%;">
          <span style="color:#000;line-height: 30px;">优惠券({{formset.length}}张)</span>
        </div>
        <div style="height: 60px"></div>
        <ul class="teamList">
            <li>
                <ul class="couponDetail" v-for="(s,$index) in formset" :key="$index">
                    <li  class="couponDetail1">{{$index+1}}</li>
                    <li  class="couponDetail2"><b>{{s.Name}}</b></li>
                    <li  class="couponDetail3">{{s.EffectiveDate}}</li>
                </ul>
            </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import thumb from "../../assets/logo.png";
import { Dialog, Toast } from "we-vue";
import wx from "weixin-js-sdk";
export default {
  name: "coupon",
  data: function () {
    return {
        imgsrc:"http://thirdwx.qlogo.cn/mmopen/PiajxSqBRaEITibBULF1IlRzqrAGs996zryjJhV2MUTgNhFSN6unoGGXOoEZXicdHYWZ9LYRLBrQ9jxlfZvYyLaRw/132",
      logourl: thumb,
      reallogourl: "",
      formset: {},
    };
  },
  created: function () {
      this.$http
      .get(
            this.GLOBAL.BASE_URL + "api/draw/getcoupons",
            {}
          )
        .then(
          function (d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.formset = rep.Data;
            } else {
            }
          },
          function (d) {
            console.log(d);
          }
        );
  },
  methods: {
  },
};
</script>


<style>
#coupon ul,#coupon ul li {
    list-style: none;
    display: inline-block;
}
#coupon ul li{
    float:left;
    font-size: 14px;
    line-height: 50px;
}
#coupon ul li img{
    width: 25px;
    border-radius: 20px;
}
#coupon .teamList
{
    width: 95%;
    margin: 0 auto;
    display: grid;
}
#coupon .teamList >li{
    width:100%;
}
#coupon .couponDetail{
    width:100%;
    background-color: #fff;
}

.couponDetail2{
    width: 34%;
    border-left: 1px solid #ddd;
}
.couponDetail3{
    width: 58%;
    text-indent: 1em;
    border-left: 1px solid #ddd;
}
.couponDetail1 {
    text-align: center;
    width:6%;
}
body{background-color: #eee;}
</style>





// WEBPACK FOOTER //
// src/components/my/coupon.vue